export default __webpack_public_path__ + "static/media/tab3_img2.fa9f9b35.png";